import { render, staticRenderFns } from "./PreloaderPlaceholder.vue?vue&type=template&id=779f68d6&"
import script from "./PreloaderPlaceholder.vue?vue&type=script&lang=js&"
export * from "./PreloaderPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports